const IconLogoutSvg = (props: any) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Icon/Fill/corner-down-right">
        <path
          id="Mask"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7812 13.0385L15.7812 8.03851C15.4362 7.60651 14.8062 7.53751 14.3762 7.88251C13.9442 8.22651 13.8742 8.85651 14.2192 9.28751L16.9202 12.6635H8.00024C7.44924 12.6635 7.00024 12.2145 7.00024 11.6635V6.66351C7.00024 6.11051 6.55224 5.66351 6.00024 5.66351C5.44824 5.66351 5.00024 6.11051 5.00024 6.66351V11.6635C5.00024 13.3175 6.34624 14.6635 8.00024 14.6635H16.9202L14.2192 18.0385C13.8742 18.4695 13.9442 19.0995 14.3762 19.4435C14.5602 19.5915 14.7812 19.6635 15.0002 19.6635C15.2932 19.6635 15.5842 19.5345 15.7812 19.2875L19.7812 14.2875C20.0732 13.9225 20.0732 13.4035 19.7812 13.0385Z"
          fill="url(#paint0_linear_1265_1426)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1265_1426"
          x1="12.5002"
          y1="5.66351"
          x2="12.5002"
          y2="19.6635"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9FFFC7" />
          <stop offset="1" stopColor="#017849" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default IconLogoutSvg
